import styled from "styled-components";

export const StyledCard = styled.div`
	background: ${(props) => props.color};
	width: ${(props) => props.width};
	height: ${(props) => props.height};
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
	border-radius: 40px;
`;
